<div class="products-container">
  <!-- Hero Section -->
  <section class="products-hero">
    <div class="hero-background">
      <div class="hero-gradient"></div>
      <div class="hero-pattern"></div>
    </div>
    <div class="container">
      <div class="hero-content" [@fadeInUp]>
       
        <h1 class="hero-title">Our Product Collection</h1>
        <p class="hero-subtitle">Crafted for global excellence and business success</p>
      </div>
    </div>
  </section>

  <!-- Products Main Section -->
  <section class="products-main">
    <div class="container">
      <div class="products-layout">
        <!-- Filters Sidebar -->
        <aside class="filters-sidebar" [@filterSlide]>
          <div class="sidebar-header">
            <h2 class="sidebar-title">
              <mat-icon>filter_alt</mat-icon>
              Filters
            </h2>
          </div>

          <!-- Search Filter -->
          <div class="filter-section">
            <h3 class="filter-title">Search Products</h3>
            <mat-form-field class="search-field">
              <mat-label>Search...</mat-label>
              <input matInput (input)="onSearchChange($event)" [value]="searchQuery" placeholder="Search products...">
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <!-- Category Filter -->
          <div class="filter-section">
            <h3 class="filter-title">Categories</h3>
            <div class="category-list">
              <button 
                *ngFor="let category of categories" 
                class="category-btn"
                [class.active]="selectedCategory === category.id"
                (click)="onCategoryChange(category.id)">
                <span class="category-name">{{ category.name }}</span>
                <span class="category-count">{{ category.count }}</span>
              </button>
            </div>
          </div>

         
        </aside>

        <!-- Products Content -->
        <main class="products-content">
          <!-- Products Header -->
          <div class="products-header">
            <div class="header-main">
              <h2 class="products-count">{{ filteredProducts.length }} Products Found</h2>
              <p class="products-subtitle">Crafted for global excellence and business success</p>
            </div>
            <div class="view-toggles">
              <button mat-button class="view-btn" [class.active]="viewMode === 'grid'" (click)="toggleView('grid')">
                <mat-icon>grid_view</mat-icon>
              </button>
              <button mat-button class="view-btn" [class.active]="viewMode === 'list'" (click)="toggleView('list')">
                <mat-icon>view_list</mat-icon>
              </button>
            </div>
          </div>

          <!-- Grid View -->
          <div *ngIf="filteredProducts.length > 0 && viewMode === 'grid'; else listView" class="products-grid" [@staggerProducts]>
            <div *ngFor="let product of filteredProducts" class="product-card">
              <!-- Product Badges -->
              <div class="product-badges">
                <span *ngIf="product.isNew" class="badge new">New</span>
                <span *ngIf="product.isSale" class="badge sale">Sale</span>
                <span *ngIf="product.isCustomizable" class="badge premium">Custom</span>
              </div>

              <!-- Product Image -->
              <div class="product-image-container">
                <img [src]="product.image" [alt]="product.name" class="product-image">
                
                <!-- Product Overlay -->
                <div class="product-overlay">
                  <div class="overlay-actions">
                    <button mat-icon-button class="overlay-btn" (click)="viewProductDetails(product)" title="View Details">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button class="overlay-btn" (click)="knowMoreOnWhatsApp(product)" title="WhatsApp Inquiry">
                      <mat-icon>chat</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Product Info -->
              <div class="product-info">
                <!-- Product Meta -->
                <div class="product-meta">
                  <span class="product-category">{{ getCategoryDisplayName(product.category) }}</span>
                  <div class="product-rating">
                    <div class="stars">
                      <mat-icon *ngFor="let star of getStars(product.rating)" [class.filled]="star === 1">star</mat-icon>
                    </div>
                    <span class="rating-text">({{ product.reviews }})</span>
                  </div>
                </div>

                <!-- Customization Info (if applicable) -->
                <div *ngIf="product.isCustomizable" class="customization-info">
                  <div class="custom-options">
                    <div class="custom-label">Customization Available</div>
                    <div class="custom-list">{{ product.customizationOptions?.slice(0, 2)?.join(', ') }}...</div>
                  </div>
                </div>

                <h3 class="product-name">{{ product.name }}</h3>
                <p class="product-description">{{ product.description }}</p>

                <!-- Product Price -->
                <div class="product-price-container">
                  <div class="price-info">
                    <span class="current-price">₹{{ product.price | number }}</span>
                    <span *ngIf="product.originalPrice" class="original-price">₹{{ product.originalPrice | number }}</span>
                    <span *ngIf="product.originalPrice" class="discount">
                      {{ ((product.originalPrice - product.price) / product.originalPrice * 100) | number:'1.0-0' }}% OFF
                    </span>
                  </div>
                </div>

                <!-- Product Actions -->
                <div class="product-actions">
                  <button mat-button class="action-btn primary" (click)="viewProductDetails(product)">
                    <mat-icon>visibility</mat-icon>
                    View Details
                  </button>
                  <button mat-icon-button class="action-btn secondary" (click)="knowMoreOnWhatsApp(product)" title="WhatsApp Inquiry">
                    <mat-icon>chat</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- List View -->
          <ng-template #listView>
            <div *ngIf="filteredProducts.length > 0; else noResults" class="products-list" [@staggerProducts]>
              <div *ngFor="let product of filteredProducts" class="product-list-item">
                <div class="list-item-content">
                  <!-- List Image -->
                  <div class="list-image-container">
                    <img [src]="product.image" [alt]="product.name" class="list-product-image">
                    <div class="list-product-badges">
                      <span *ngIf="product.isNew" class="badge new">New</span>
                      <span *ngIf="product.isSale" class="badge sale">Sale</span>
                      <span *ngIf="product.isCustomizable" class="badge premium">Custom</span>
                    </div>
                  </div>

                  <!-- List Product Info -->
                  <div class="list-product-info">
                    <div class="list-product-meta">
                      <span class="product-category">{{ getCategoryDisplayName(product.category) }}</span>
                      <div class="product-rating">
                        <div class="stars">
                          <mat-icon *ngFor="let star of getStars(product.rating)" [class.filled]="star === 1">star</mat-icon>
                        </div>
                        <span class="rating-text">({{ product.reviews }})</span>
                      </div>
                    </div>

                    <h3 class="list-product-name">{{ product.name }}</h3>
                    <p class="list-product-description">{{ product.description }}</p>

                    <!-- Customization Info (if applicable) -->
                    <div *ngIf="product.isCustomizable" class="customization-info">
                      <div class="custom-options">
                        <div class="custom-label">Customization Available</div>
                        <div class="custom-list">{{ product.customizationOptions?.slice(0, 3)?.join(', ') }}</div>
                      </div>
                    </div>

                    <div class="list-price-container">
                      <div class="price-info">
                        <span class="current-price">₹{{ product.price | number }}</span>
                        <span *ngIf="product.originalPrice" class="original-price">₹{{ product.originalPrice | number }}</span>
                        <span *ngIf="product.originalPrice" class="discount">
                          {{ ((product.originalPrice - product.price) / product.originalPrice * 100) | number:'1.0-0' }}% OFF
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- List Actions -->
                  <div class="list-product-actions">
                    <button mat-button class="action-btn primary" (click)="viewProductDetails(product)">
                      <mat-icon>visibility</mat-icon>
                      View Details
                    </button>
                    <button mat-icon-button class="list-view-btn" (click)="knowMoreOnWhatsApp(product)" title="WhatsApp Inquiry">
                      <mat-icon>chat</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- No Results -->
          <ng-template #noResults>
            <div class="no-results">
              <div class="no-results-content">
                <div class="no-results-icon">
                  <mat-icon>inventory_2</mat-icon>
                </div>
                <h3>No Products Found</h3>
                <p>We couldn't find any products matching your criteria. Try adjusting your filters or search terms.</p>
                <button mat-button class="reset-btn" (click)="resetFilters()">
                  <mat-icon>refresh</mat-icon>
                  Reset Filters
                </button>
              </div>
            </div>
          </ng-template>
        </main>
      </div>
    </div>
  </section>
</div>

<!-- Product Details Modal -->
<div *ngIf="showProductDetails" class="product-details-overlay" (click)="closeProductDetails()">
  <div class="product-details-modal" (click)="$event.stopPropagation()" [@slideIn]>
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">{{ selectedProduct?.name }}</h2>
      <button mat-icon-button class="close-btn" (click)="closeProductDetails()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="product-details-grid">
        <!-- Product Image -->
        <div class="details-image-section">
          <img [src]="selectedProduct?.image" [alt]="selectedProduct?.name" class="details-image">
          <div class="details-badges">
            <span *ngIf="selectedProduct?.isNew" class="badge new">New</span>
            <span *ngIf="selectedProduct?.isSale" class="badge sale">Sale</span>
            <span *ngIf="selectedProduct?.isCustomizable" class="badge premium">Custom</span>
          </div>
        </div>

        <!-- Product Information -->
        <div class="details-info-section">
          <!-- Basic Info -->
          <div class="basic-info">
            <div class="product-meta">
              <span class="product-category">{{ getCategoryDisplayName(selectedProduct?.category || '') }}</span>
              <div class="product-rating">
                <div class="stars">
                  <mat-icon *ngFor="let star of getStars(selectedProduct?.rating || 0)" [class.filled]="star === 1">star</mat-icon>
                </div>
                <span class="rating-text">({{ selectedProduct?.reviews }} reviews)</span>
              </div>
            </div>

            <p class="product-description">{{ selectedProduct?.description }}</p>

            <!-- Price Info -->
            <div class="price-section">
              <div class="price-info">
                <span class="current-price">₹{{ selectedProduct?.price | number }}</span>
                <span *ngIf="selectedProduct?.originalPrice" class="original-price">₹{{ selectedProduct?.originalPrice | number }}</span>
                <span *ngIf="selectedProduct?.originalPrice" class="discount">
                  {{ ((selectedProduct!.originalPrice! - selectedProduct!.price) / selectedProduct!.originalPrice! * 100) | number:'1.0-0' }}% OFF
                </span>
              </div>
            </div>
          </div>

          <!-- Detailed Specifications -->
          <div class="specifications-section">
            <h3 class="section-title">
              <mat-icon>info</mat-icon>
              Product Specifications
            </h3>
            
            <div class="specs-grid">
              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>texture</mat-icon>
                  Material
                </div>
                <div class="spec-value">Cotton, Canvas, Jute & Polypropylene (Hubco)</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>straighten</mat-icon>
                  Size Options
                </div>
                <div class="spec-value">6x8, 8x10, 10x12, 12x14, 14x16, 16x18 and customize</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>palette</mat-icon>
                  Available Colors
                </div>
                <div class="spec-value">White and Off White</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>scale</mat-icon>
                  Capacity Range
                </div>
                <div class="spec-value">100 grams to 10kg or more</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>flag</mat-icon>
                  Country of Origin
                </div>
                <div class="spec-value">Made in India</div>
              </div>

              <div class="spec-item">
                <div class="spec-label">
                  <mat-icon>shopping_cart</mat-icon>
                  Minimum Order
                </div>
                <div class="spec-value">5000 Bags</div>
              </div>
            </div>
          </div>

          <!-- Product Features -->
          <div class="features-section">
            <h3 class="section-title">
              <mat-icon>stars</mat-icon>
              Key Features
            </h3>
            
            <div class="features-content">
              <p class="features-description">
                Cotton bags for Geological soil samples are designed for the collection of rock, mineral, and geochemical soil samples. 
                All bags have a drawstring closure and sewn in 2" x 3" waterproof white tag. The tags are double-sided with one side 
                blank and the other with a standard sample format.
              </p>

              <div class="feature-highlights">
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Writable Panels</strong> – For clear labeling and sample ID tracking</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Multiple Sizes Available</strong> – Perfect for everything from handheld grab samples to bulk collections</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Waterproof Tags</strong> – Durable identification in all weather conditions</span>
                </div>
                <div class="feature-point">
                  <mat-icon>check_circle</mat-icon>
                  <span><strong>Drawstring Closure</strong> – Secure and easy-to-use closure system</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Customization Options (if applicable) -->
          <div *ngIf="selectedProduct?.isCustomizable" class="customization-section">
            <h3 class="section-title">
              <mat-icon>brush</mat-icon>
              Customization Options
            </h3>
            
            <div class="custom-options-grid">
              <div *ngFor="let option of selectedProduct?.customizationOptions" class="custom-option">
                <mat-icon>check</mat-icon>
                <span>{{ option }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      <button mat-button class="action-btn secondary" (click)="closeProductDetails()">
        <mat-icon>close</mat-icon>
        Close
      </button>
      <button mat-button class="action-btn primary" (click)="knowMoreOnWhatsApp(selectedProduct!)">
        <mat-icon>chat</mat-icon>
        WhatsApp Inquiry
      </button>
      <button *ngIf="selectedProduct?.isCustomizable" mat-button class="action-btn customize" (click)="customizeInquiry(selectedProduct!)">
        <mat-icon>brush</mat-icon>
        Customize Order
      </button>
    </div>
  </div>
</div>
